import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

export const useI18nValues = () => {
  const { t } = useTranslation('entities/personalIdentifiers', { keyPrefix: 'types' });

  return useMemo(
    () => ({
      type: (type: PersonalIdentifierType) => t(i18nMap[type]),
    }),
    [t],
  );
};

const i18nMap = {
  [PersonalIdentifierType.BIRTH_CERTIFICATE]: 'birthCertificate',
  [PersonalIdentifierType.DRIVER_LICENSE]: 'driverLicense',
  [PersonalIdentifierType.EDUCATION]: 'education',
  [PersonalIdentifierType.FREE_BLOCK]: 'freeBlock',
  [PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE]: 'internationalDriverLicense',
  [PersonalIdentifierType.MEDICAL_ID]: 'medicalId',
  [PersonalIdentifierType.MILITARY_ID]: 'militaryId',
  [PersonalIdentifierType.NATIONAL_ID]: 'nationalId',
  [PersonalIdentifierType.PASSPORT]: 'passport',
  [PersonalIdentifierType.RESIDENCE_PERMIT]: 'residencePermit',
  [PersonalIdentifierType.SOCIAL_SECURITY]: 'socialSecurity',
  [PersonalIdentifierType.SUBSTANCE]: 'substance',
  [PersonalIdentifierType.TAX_ID]: 'taxId',
  [PersonalIdentifierType.CITIZENSHIP_CERTIFICATE]: 'citizenshipCertificate',
};
